import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { CampaignCodeForm } from '@lean-body/components/molecules';
import { Colors } from '../styles';
import { ArrowDirection, ArrowIcon } from '../atoms/icons/arrow_icon';
import { LocalStorage } from '@lean-body/src/infra';
import { CampaignPlanSection } from './campaign_plan_section';
/**
 * キャンペーンコード入力セクション
 */
export const CampaignCodeFormSection = ({ classObject, isBulkRegistration, isCampaignSimplifiedView, campaignPlan, defaultCampaign, withCampaignParams, apiClient, friendInvitationCampaign, onSubmit, }) => {
    const localStorage = new LocalStorage();
    const [value, setValue] = React.useState('');
    const [isShowForm, setIsShowForm] = React.useState(false);
    const onChangeKeyword = (e) => {
        setValue(e.target.value.trim());
    };
    const handleOnSubmit = () => {
        onSubmit(value, false).then(() => {
            localStorage.saveCampaingCode(value);
        });
    };
    if (defaultCampaign) {
        return (React.createElement(CampaignPlanSection, { isBulkRegistration: isBulkRegistration, isCampaignSimplifiedView: isCampaignSimplifiedView, campaign: defaultCampaign, campaignPlan: campaignPlan, withCampaignParams: withCampaignParams, apiClient: apiClient, friendInvitationCampaign: friendInvitationCampaign }));
    }
    return (React.createElement("div", { className: css(classObject) },
        React.createElement("div", { className: css(styles.container, isShowForm && styles.containerOpened) },
            React.createElement("div", { className: css(styles.switch), onClick: () => setIsShowForm(!isShowForm), id: 'campaign-code', "data-test": "campaignCodeDisplayable" },
                "\u30AF\u30FC\u30DD\u30F3\u30B3\u30FC\u30C9\u3092\u304A\u6301\u3061\u306E\u65B9",
                React.createElement(ArrowIcon, { classObject: styles.arrow, direction: isShowForm ? ArrowDirection.top : ArrowDirection.bottom })),
            isShowForm && (React.createElement(CampaignCodeForm, { value: value, onChangeKeyword: onChangeKeyword, submitDisabled: value.length === 0, onSubmit: handleOnSubmit, classObject: styles.form })))));
};
const styles = StyleSheet.create({
    container: {
        maxHeight: 22,
        overflow: 'hidden',
        transition: 'max-height 0.2s',
    },
    containerOpened: {
        maxHeight: 100,
    },
    campaignName: {
        color: Colors.Accent,
    },
    switch: {
        fontSize: 14,
        fontWeight: 'bold',
        color: Colors.PrimaryDark,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
    },
    arrow: {
        marginLeft: 10,
        width: 14,
        height: 8,
    },
    form: {
        marginTop: 20,
    },
});
